var _rect, _rect2, _path, _path2, _path3, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaGenericpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11L40 11",
    stroke: "#D3D3D3",
    strokeWidth: 4.22414
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41406 17.0344H24.9141",
    stroke: "#D3D3D3",
    strokeWidth: 1.2069,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41406 21.2587H19.483",
    stroke: "#D3D3D3",
    strokeWidth: 1.2069,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1553,
    y: 17.6379,
    width: 6.03448,
    height: 4.22414,
    rx: 1.2069,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaGenericpay);
export default __webpack_public_path__ + "static/media/aa-genericpay.1dfc558e9cdd4340d2a69ada4f1a7d09.svg";
export { ForwardRef as ReactComponent };